<template>
  <div>
    <Navbar></Navbar>
    <div class="flex head">
      <van-card
        :key="form.id"
        :title="form.name"
        :thumb="
          form.picture ||
          'https://fastly.jsdelivr.net/npm/@vant/assets/ipad.jpeg'
        "
      >
        <template #desc>
          <div></div>
          <div>商品条码: {{ form.externalCode }}</div>
          <div>商品代码: {{ form.skuCode }}</div>
        </template>
      </van-card>
      <van-button
        size="small"
        class="fs14"
        @click="toAnalysis(form.id)"
        type="primary"
        v-if="form.id"
        >销售查询</van-button
      >
    </div>
    <van-tabs v-model="active">
      <van-tab v-for="item in tabsList" :name="item.name" :title="item.name">
        <DetailPage :content="item.content" :data="form" />
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import DetailPage from "@/components/detailPage";
import { get } from "../../service/api/product";
import Navbar from "../../components/navbar.vue";

export default {
  name: "index",
  components: { DetailPage, Navbar },
  data() {
    return {
      form: {},
      active: "档案",
      tabsList: [
        {
          name: "档案",
          content: {
            title: "详情",
            rows: [
              {
                label: "类别",
                key: "categoryName",
                editable: false,
              },
              {
                label: "基本单位",
                key: "unit",
                editable: false,
              },
              {
                label: "零售价",
                key: "retailPrice",
                editable: false,
              },
            ],
          },
        },
        {
          name: "采购",
          content: {
            title: "供应商",
            type: "Array",
            key: "supplierList",
            rows: [
              {
                label: "供应商名称",
                key: "name",
                editable: false,
              },

              {
                label: "采购价格",
                key: "purchasePrice",
                editable: false,
              },
            ],
          },
        },
        {
          name: "库存",
          content: {
            title: "库存",
            type: "Array",
            key: "scList",
            rows: [
              {
                label: "仓库名称",
                key: "name",
                editable: false,
              },
              {
                label: "库存数量",
                key: "stockNum",
                editable: false,
              },
            ],
          },
        },
      ],
    };
  },
  created() {},
  mounted() {
    this.getInfo();
  },
  methods: {
    async getInfo() {
      const id = this.$route.params.id;
      const res = await get(id);
      this.form = { ...res.data, available: res.data.available ? "1" : "0" };
    },
    toAnalysis(id) {
      const preRoute = { path: this.$route.path };
      localStorage.setItem("preRoute", JSON.stringify(preRoute));
      this.$router.push("/analysis/orderList/" + id);
    },
  },
};
</script>
<style lang="less" scoped>
.head {
  background-color: #fff;
  align-items: center;
  .van-card {
    padding: 8px 2px;
    background-color: #fff;
    .van-card__thumb {
      width: 78px;
      height: 78px;
    }
    .van-card__title {
      font-weight: 600;
      font-size: 16px;
    }
  }
  .van-button {
    border-radius: 10px;
    padding: 0 2px;
  }
}
</style>
